import React from "react";
import { CommentSection } from "./_UI/CommentSection";
import { ArticleHeader } from "./_UI/ArticleHeader";

import { useParams } from "react-router-dom";
import { getSingleBlog } from "../../lib/firebase/blogs";
import { Spin } from "antd";


function SingleArticle() {
  // const { pid } = await params;
  const params = useParams();
  const pid = params.id;
  // const post = await getSingleBlog(pid);
  const [post, setPost] = React.useState(null);
  React.useEffect(() => {
    (async () => {
      try {
        const post = await getSingleBlog(pid);
        setPost(post);
      } catch (error) {
        console.error(error);
      }
    })();
  })
  if (!post) {
    return (
      <Spin size="large" fullscreen />
    );
  }
  return (
    <div className="min-h-screen bg-black text-white">
      <main className="max-w-7xl mx-auto shadow-lg shadow-gray-600 rounded-xl px-4 py-10 bg-gray-900">
        <article className="rounded-xl shadow-sm p-6 md:p-8 overflow-hidden">
          <ArticleHeader
            title={post.title}
            author={{ name: post.user, avatar: "" }}
            user={post.user}
            date={post.date}
            readingTime={"5"}
            category={post.category}
            tags={[]}
          />

          <div
            className="prose prose-lg max-w-none text-gray-200 mt-8 border-b overflow-x-auto pb-10"
            dangerouslySetInnerHTML={{ __html: post.content }}
          />

          <CommentSection post={post} />
        </article>
      </main>
    </div>
  );
}

export default SingleArticle;
